




















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import * as fileStorage from "@/domain/fileStorage";
import * as util from "@/util";

@Component
export default class LinkRef extends Vue {
  @Prop({ required: true }) fileRef!: string;

  file = fileStorage.newFileRef("");

  get needsToLoad(): boolean {
    return this.fileRef !== this.file.ref || (!!this.file.ref && !this.file.url && !this.file.loading);
  }

  @Watch("fileRef")
  onChange() {
    this.refresh();
  }

  refresh() {
    if (this.needsToLoad) {
      this.file = fileStorage.newFileRef(this.fileRef);
      util.promiseEnd(fileStorage.resolveFile(this.file));
    }
  }

  created() {
    this.refresh();
  }

  get lang() {
    return this.$store.state.lang.data;
  }
}
